import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-cookie-policy-dialog',
  standalone: true,
  imports: [TranslateModule, MatDialogModule],
  templateUrl: './cookie-policy-dialog.component.html',
  styleUrls: ['./cookie-policy-dialog.component.scss'],
})
export class CookiePolicyDialogComponent {
}